export { default } from "./FiltersBar.jsx"
